import {queryConfigs} from 'data/queryConfigs'
import {queryClient} from 'main'

export const getCurrentOrganization = () =>
  queryClient.fetchQuery(queryConfigs.auth.currentOrganization)
